import sharedRoutePaths from "@/shared/router/routePaths";

export default {
  ...sharedRoutePaths,
  companyDocumentsUpload: "/upload/company-documents/:nextStep?",
  corporateKYCWelcome: "/corporate-kyc-welcome",
  questionnaireCorporate: "/questionnaire-corporate/:questionType?",
};
